<template>
    <div class="card mb-4">
        <div class="card-body">
            <div class="row mb-3">
                <div class="col d-flex align-items-center">
                    <h2 class="card-title mb-0">Addresses</h2>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-link" v-c-modal:addressesModal="{}">
                        <i class="far fa-pencil-alt"></i> Edit
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <h3>Physical Address</h3>
                    <p>
                        <template v-if="client.address_line_1">
                            {{ client.address_line_1 }}<br>
                            <template v-if="client.address_line_2">{{ client.address_line_2 }}<br></template>
                            {{ client.city }} {{ client.postcode }}<br>
                            {{ client.country }}
                        </template>
                        <template v-else>-</template>
                    </p>
                </div>
                <div class="col-md-6">
                    <h3>Postal Address</h3>
                    <p>
                        <template v-if="client.postal_address_line_1">
                            {{ client.postal_address_line_1 }}<br>
                            <template v-if="client.postal_address_line_2">{{ client.postal_address_line_2 }}<br></template>
                            {{ client.postal_city }} {{ client.postal_postcode }}<br>
                            {{ client.postal_country }}
                        </template>
                        <template v-else>-</template>
                    </p>
                </div>
            </div>
        </div>

        <client-addresses-modal ref="addressesModal" :client="client" />
    </div>
</template>

<script>
import ClientAddressesModal from './ClientAddressesModal'

export default {
    props: ['client'],

    components: {
        ClientAddressesModal
    }
};
</script>
